// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.19.1
// source: process_point.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Location, TimeRange, Timestamp } from "./base";
import { File } from "./file";
import { Struct } from "./google/protobuf/struct";
import { HealthLevel } from "./health";
import { Tag, TagSelection } from "./tag";
import {
  Value_Numeric_Rate,
  Value_Numeric_Type,
  value_Numeric_TypeFromJSON,
  value_Numeric_TypeToNumber,
} from "./value";

export const protobufPackage = "hiber.processpoint";

/**
 * Process Points are things that collect the data produced by devices.
 * Devices are assigned to process points to handle data ownership.
 * When a device is replaced, the data flow for the process point continues with the data from the new device.
 * Multiple devices can be assigned to an process point, though it is advisable to only do so when they send
 * different type of data (e.g. one sensor for pressure and one for flow).
 *
 * For example, if you have a Well, you might have process points for Annulus A and the tubing head.
 */
export interface ProcessPoint {
  identifier: string;
  /** Name of the process point */
  name: string;
  /** Type of the process point, if any of the predefined types applies. */
  type?:
    | ProcessPoint_Type
    | undefined;
  /** Longer detailed description of the process point. */
  description?:
    | string
    | undefined;
  /** Multiline notes field that can be used to add additional information to an process point. */
  notes?:
    | string
    | undefined;
  /**
   * Optional time zone for the process point.
   * This can, for example, be used to calculate SLAs on a daily basis, adjusted by time zone.
   */
  timeZone?:
    | string
    | undefined;
  /** The expected transmission rate for this process point. */
  expectedTransmissionRate?:
    | Value_Numeric_Rate
    | undefined;
  /**
   * Metadata for the process point.
   * This can be automatically populated from linked devices or manually added.
   */
  metadata:
    | { [key: string]: any }
    | undefined;
  /** Tags assigned to this process point */
  tags: Tag[];
  /** Devices assigned to this process point */
  devices: ProcessPoint_AssignedDevice[];
  /** Devices that were assigned to this process point in the past */
  inactiveDevices: ProcessPoint_AssignedDevice[];
  /**
   * The organization that owns this process point.
   * Typically only relevant if child organizations are included.
   */
  organization: string;
  /** Location for the process point. */
  location:
    | Location
    | undefined;
  /**
   * Files for this process point.
   * Typically an image of a place. See the File.media_type for more information.
   */
  files: File[];
}

/**
 * Predefined process points types that can be used to say something about the data.
 * Currently a limited list, but more may be added in the future.
 */
export enum ProcessPoint_Type {
  UNKNOWN = "UNKNOWN",
  WELL_ANNULUS_A = "WELL_ANNULUS_A",
  WELL_ANNULUS_B = "WELL_ANNULUS_B",
  WELL_ANNULUS_C = "WELL_ANNULUS_C",
  WELL_ANNULUS_D = "WELL_ANNULUS_D",
  WELL_HEAD = "WELL_HEAD",
  WELL_TUBING_HEAD = "WELL_TUBING_HEAD",
  WELL_TUBING = "WELL_TUBING",
  WELL_FLOW_LINE = "WELL_FLOW_LINE",
  WELL_CASING = "WELL_CASING",
  WELL_PRODUCTION_CASING_PRESSURE = "WELL_PRODUCTION_CASING_PRESSURE",
  WELL_INTERMITTENT_CASING_PRESSURE = "WELL_INTERMITTENT_CASING_PRESSURE",
  PIPELINE = "PIPELINE",
  PRODUCTION_LINE = "PRODUCTION_LINE",
  GAS_MANIFOLD = "GAS_MANIFOLD",
  PRODUCTION_MANIFOLD = "PRODUCTION_MANIFOLD",
  TEMPERATURE = "TEMPERATURE",
  METERING_FLOWLINE = "METERING_FLOWLINE",
  VALVE = "VALVE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function processPoint_TypeFromJSON(object: any): ProcessPoint_Type {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ProcessPoint_Type.UNKNOWN;
    case 1:
    case "WELL_ANNULUS_A":
      return ProcessPoint_Type.WELL_ANNULUS_A;
    case 2:
    case "WELL_ANNULUS_B":
      return ProcessPoint_Type.WELL_ANNULUS_B;
    case 3:
    case "WELL_ANNULUS_C":
      return ProcessPoint_Type.WELL_ANNULUS_C;
    case 4:
    case "WELL_ANNULUS_D":
      return ProcessPoint_Type.WELL_ANNULUS_D;
    case 15:
    case "WELL_HEAD":
      return ProcessPoint_Type.WELL_HEAD;
    case 5:
    case "WELL_TUBING_HEAD":
      return ProcessPoint_Type.WELL_TUBING_HEAD;
    case 6:
    case "WELL_TUBING":
      return ProcessPoint_Type.WELL_TUBING;
    case 7:
    case "WELL_FLOW_LINE":
      return ProcessPoint_Type.WELL_FLOW_LINE;
    case 8:
    case "WELL_CASING":
      return ProcessPoint_Type.WELL_CASING;
    case 9:
    case "WELL_PRODUCTION_CASING_PRESSURE":
      return ProcessPoint_Type.WELL_PRODUCTION_CASING_PRESSURE;
    case 10:
    case "WELL_INTERMITTENT_CASING_PRESSURE":
      return ProcessPoint_Type.WELL_INTERMITTENT_CASING_PRESSURE;
    case 11:
    case "PIPELINE":
      return ProcessPoint_Type.PIPELINE;
    case 12:
    case "PRODUCTION_LINE":
      return ProcessPoint_Type.PRODUCTION_LINE;
    case 13:
    case "GAS_MANIFOLD":
      return ProcessPoint_Type.GAS_MANIFOLD;
    case 14:
    case "PRODUCTION_MANIFOLD":
      return ProcessPoint_Type.PRODUCTION_MANIFOLD;
    case 16:
    case "TEMPERATURE":
      return ProcessPoint_Type.TEMPERATURE;
    case 17:
    case "METERING_FLOWLINE":
      return ProcessPoint_Type.METERING_FLOWLINE;
    case 18:
    case "VALVE":
      return ProcessPoint_Type.VALVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProcessPoint_Type.UNRECOGNIZED;
  }
}

export function processPoint_TypeToNumber(object: ProcessPoint_Type): number {
  switch (object) {
    case ProcessPoint_Type.UNKNOWN:
      return 0;
    case ProcessPoint_Type.WELL_ANNULUS_A:
      return 1;
    case ProcessPoint_Type.WELL_ANNULUS_B:
      return 2;
    case ProcessPoint_Type.WELL_ANNULUS_C:
      return 3;
    case ProcessPoint_Type.WELL_ANNULUS_D:
      return 4;
    case ProcessPoint_Type.WELL_HEAD:
      return 15;
    case ProcessPoint_Type.WELL_TUBING_HEAD:
      return 5;
    case ProcessPoint_Type.WELL_TUBING:
      return 6;
    case ProcessPoint_Type.WELL_FLOW_LINE:
      return 7;
    case ProcessPoint_Type.WELL_CASING:
      return 8;
    case ProcessPoint_Type.WELL_PRODUCTION_CASING_PRESSURE:
      return 9;
    case ProcessPoint_Type.WELL_INTERMITTENT_CASING_PRESSURE:
      return 10;
    case ProcessPoint_Type.PIPELINE:
      return 11;
    case ProcessPoint_Type.PRODUCTION_LINE:
      return 12;
    case ProcessPoint_Type.GAS_MANIFOLD:
      return 13;
    case ProcessPoint_Type.PRODUCTION_MANIFOLD:
      return 14;
    case ProcessPoint_Type.TEMPERATURE:
      return 16;
    case ProcessPoint_Type.METERING_FLOWLINE:
      return 17;
    case ProcessPoint_Type.VALVE:
      return 18;
    case ProcessPoint_Type.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * A device assigned to this process point.
 * Non-operational values that the device produces will be linked to this process point
 * (e.g. pressure, but not battery level).
 */
export interface ProcessPoint_AssignedDevice {
  number: string;
  identifiers: string[];
  name?: string | undefined;
  type?: string | undefined;
  lastMessageSentAt?: Timestamp | undefined;
  lastMessageReceivedAt?: Timestamp | undefined;
  assignmentTimeRange?: TimeRange | undefined;
  health?: HealthLevel | undefined;
  numericValueTypes: Value_Numeric_Type[];
}

/** Selection object for process points. */
export interface ProcessPointSelection {
  /** Select process points by identifier. */
  identifiers: string[];
  /** Select process points by name. */
  names: string[];
  /** Search process points by (partial, case insensitive) identifier, name, description, notes and time zone. */
  search: string[];
  /** Select process points by type. */
  types: ProcessPoint_Type[];
  /** Select process points by tags */
  filterByTags?: TagSelection | undefined;
}

function createBaseProcessPoint(): ProcessPoint {
  return {
    identifier: "",
    name: "",
    type: undefined,
    description: undefined,
    notes: undefined,
    timeZone: undefined,
    expectedTransmissionRate: undefined,
    metadata: undefined,
    tags: [],
    devices: [],
    inactiveDevices: [],
    organization: "",
    location: undefined,
    files: [],
  };
}

export const ProcessPoint = {
  encode(message: ProcessPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.type !== undefined) {
      writer.uint32(24).int32(processPoint_TypeToNumber(message.type));
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.notes !== undefined) {
      writer.uint32(42).string(message.notes);
    }
    if (message.timeZone !== undefined) {
      writer.uint32(50).string(message.timeZone);
    }
    if (message.expectedTransmissionRate !== undefined) {
      Value_Numeric_Rate.encode(message.expectedTransmissionRate, writer.uint32(58).fork()).ldelim();
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.tags) {
      Tag.encode(v!, writer.uint32(74).fork()).ldelim();
    }
    for (const v of message.devices) {
      ProcessPoint_AssignedDevice.encode(v!, writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.inactiveDevices) {
      ProcessPoint_AssignedDevice.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    if (message.organization !== "") {
      writer.uint32(90).string(message.organization);
    }
    if (message.location !== undefined) {
      Location.encode(message.location, writer.uint32(106).fork()).ldelim();
    }
    for (const v of message.files) {
      File.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProcessPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.identifier = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = processPoint_TypeFromJSON(reader.int32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.timeZone = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.expectedTransmissionRate = Value_Numeric_Rate.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.tags.push(Tag.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.devices.push(ProcessPoint_AssignedDevice.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.inactiveDevices.push(ProcessPoint_AssignedDevice.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.location = Location.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.files.push(File.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ProcessPoint>): ProcessPoint {
    return ProcessPoint.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessPoint>): ProcessPoint {
    const message = createBaseProcessPoint();
    message.identifier = object.identifier ?? "";
    message.name = object.name ?? "";
    message.type = object.type ?? undefined;
    message.description = object.description ?? undefined;
    message.notes = object.notes ?? undefined;
    message.timeZone = object.timeZone ?? undefined;
    message.expectedTransmissionRate =
      (object.expectedTransmissionRate !== undefined && object.expectedTransmissionRate !== null)
        ? Value_Numeric_Rate.fromPartial(object.expectedTransmissionRate)
        : undefined;
    message.metadata = object.metadata ?? undefined;
    message.tags = object.tags?.map((e) => Tag.fromPartial(e)) || [];
    message.devices = object.devices?.map((e) => ProcessPoint_AssignedDevice.fromPartial(e)) || [];
    message.inactiveDevices = object.inactiveDevices?.map((e) => ProcessPoint_AssignedDevice.fromPartial(e)) || [];
    message.organization = object.organization ?? "";
    message.location = (object.location !== undefined && object.location !== null)
      ? Location.fromPartial(object.location)
      : undefined;
    message.files = object.files?.map((e) => File.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProcessPoint_AssignedDevice(): ProcessPoint_AssignedDevice {
  return {
    number: "",
    identifiers: [],
    name: undefined,
    type: undefined,
    lastMessageSentAt: undefined,
    lastMessageReceivedAt: undefined,
    assignmentTimeRange: undefined,
    health: undefined,
    numericValueTypes: [],
  };
}

export const ProcessPoint_AssignedDevice = {
  encode(message: ProcessPoint_AssignedDevice, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.number !== "") {
      writer.uint32(10).string(message.number);
    }
    for (const v of message.identifiers) {
      writer.uint32(18).string(v!);
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    if (message.type !== undefined) {
      writer.uint32(34).string(message.type);
    }
    if (message.lastMessageSentAt !== undefined) {
      Timestamp.encode(message.lastMessageSentAt, writer.uint32(42).fork()).ldelim();
    }
    if (message.lastMessageReceivedAt !== undefined) {
      Timestamp.encode(message.lastMessageReceivedAt, writer.uint32(50).fork()).ldelim();
    }
    if (message.assignmentTimeRange !== undefined) {
      TimeRange.encode(message.assignmentTimeRange, writer.uint32(58).fork()).ldelim();
    }
    if (message.health !== undefined) {
      HealthLevel.encode(message.health, writer.uint32(66).fork()).ldelim();
    }
    writer.uint32(74).fork();
    for (const v of message.numericValueTypes) {
      writer.int32(value_Numeric_TypeToNumber(v));
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProcessPoint_AssignedDevice {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessPoint_AssignedDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.number = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.identifiers.push(reader.string());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.type = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.lastMessageSentAt = Timestamp.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.lastMessageReceivedAt = Timestamp.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.assignmentTimeRange = TimeRange.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.health = HealthLevel.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag === 72) {
            message.numericValueTypes.push(value_Numeric_TypeFromJSON(reader.int32()));

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.numericValueTypes.push(value_Numeric_TypeFromJSON(reader.int32()));
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ProcessPoint_AssignedDevice>): ProcessPoint_AssignedDevice {
    return ProcessPoint_AssignedDevice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessPoint_AssignedDevice>): ProcessPoint_AssignedDevice {
    const message = createBaseProcessPoint_AssignedDevice();
    message.number = object.number ?? "";
    message.identifiers = object.identifiers?.map((e) => e) || [];
    message.name = object.name ?? undefined;
    message.type = object.type ?? undefined;
    message.lastMessageSentAt = (object.lastMessageSentAt !== undefined && object.lastMessageSentAt !== null)
      ? Timestamp.fromPartial(object.lastMessageSentAt)
      : undefined;
    message.lastMessageReceivedAt =
      (object.lastMessageReceivedAt !== undefined && object.lastMessageReceivedAt !== null)
        ? Timestamp.fromPartial(object.lastMessageReceivedAt)
        : undefined;
    message.assignmentTimeRange = (object.assignmentTimeRange !== undefined && object.assignmentTimeRange !== null)
      ? TimeRange.fromPartial(object.assignmentTimeRange)
      : undefined;
    message.health = (object.health !== undefined && object.health !== null)
      ? HealthLevel.fromPartial(object.health)
      : undefined;
    message.numericValueTypes = object.numericValueTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseProcessPointSelection(): ProcessPointSelection {
  return { identifiers: [], names: [], search: [], types: [], filterByTags: undefined };
}

export const ProcessPointSelection = {
  encode(message: ProcessPointSelection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.identifiers) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.search) {
      writer.uint32(18).string(v!);
    }
    writer.uint32(26).fork();
    for (const v of message.types) {
      writer.int32(processPoint_TypeToNumber(v));
    }
    writer.ldelim();
    if (message.filterByTags !== undefined) {
      TagSelection.encode(message.filterByTags, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProcessPointSelection {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessPointSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.identifiers.push(reader.string());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.search.push(reader.string());
          continue;
        case 3:
          if (tag === 24) {
            message.types.push(processPoint_TypeFromJSON(reader.int32()));

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.types.push(processPoint_TypeFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.filterByTags = TagSelection.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ProcessPointSelection>): ProcessPointSelection {
    return ProcessPointSelection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessPointSelection>): ProcessPointSelection {
    const message = createBaseProcessPointSelection();
    message.identifiers = object.identifiers?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.search = object.search?.map((e) => e) || [];
    message.types = object.types?.map((e) => e) || [];
    message.filterByTags = (object.filterByTags !== undefined && object.filterByTags !== null)
      ? TagSelection.fromPartial(object.filterByTags)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
